import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=62dfabbd&"
import script from "./checkbox-group.vue?vue&type=script&lang=ts&"
export * from "./checkbox-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62dfabbd')) {
      api.createRecord('62dfabbd', component.options)
    } else {
      api.reload('62dfabbd', component.options)
    }
    module.hot.accept("./checkbox-group.vue?vue&type=template&id=62dfabbd&", function () {
      api.rerender('62dfabbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/question-components/checkbox-group/checkbox-group.vue"
export default component.exports